export enum DisplayType {
    JSON_TABLE = 'json_table',
    DISABLED_TEXT = 'disabled_text',
    MESSAGE = 'message'
}


interface DisabledTextOptions {
    label: string;
}


interface DependencyOptions {
    dependsOn: string;
    hideOn: string[];
}


export interface DisplayField {
    key: string;
    displayType: DisplayType;
    displayOptions: DisabledTextOptions|null;
    dependencyOptions: DependencyOptions|null;
}
